import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";
import { RANGER_AVATAR } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!loading && user) nav("/admin/dashboard"); }, [user, loading, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] grain flex items-center justify-center px-4">
      <Seo title="Admin" description="Visit RiNo admin console" />
      <div className="relative z-10 w-full max-w-md border border-white/10 bg-[#141414] p-8">
        <div className="flex items-center gap-3 mb-8">
          <img src={RANGER_AVATAR} alt="Visit RiNo" className="w-12 h-12 object-cover border border-[#FF0055]" />
          <div>
            <div className="font-display font-extrabold text-xl text-white">VISIT<span className="text-[#FF0055]">RiNo</span></div>
            <div className="font-accent text-[10px] text-[#00E5FF]">Admin Console</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-neutral-400 text-xs font-accent">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 bg-transparent border border-white/15 px-3 py-2.5 text-sm text-white outline-none focus:border-[#00E5FF]" />
          </div>
          <div>
            <label className="text-neutral-400 text-xs font-accent">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 bg-transparent border border-white/15 px-3 py-2.5 text-sm text-white outline-none focus:border-[#00E5FF]" />
          </div>
          {error && <div className="text-[#FF0055] text-sm" data-testid="admin-error">{error}</div>}
          <Button type="submit" disabled={busy} data-testid="admin-login-btn" className="w-full bg-[#FF0055] hover:bg-[#ff2d74] rounded-none h-11 font-semibold">
            <Lock size={15} /> {busy ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
